var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8 15.6H13.2C12.8818 15.6 12.5766 15.4736 12.3515 15.2485C12.1265 15.0235 12 14.7182 12 14.4V11.4C12 11.2409 11.9368 11.0882 11.8243 10.9757C11.7118 10.8632 11.5592 10.8 11.4 10.8H10.8",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7 7.79999C11.6407 7.79999 11.5827 7.81758 11.5334 7.85055C11.484 7.88351 11.4456 7.93037 11.4229 7.98518C11.4002 8.04 11.3942 8.10032 11.4058 8.15851C11.4174 8.21671 11.4459 8.27016 11.4879 8.31212C11.5298 8.35408 11.5833 8.38265 11.6415 8.39422C11.6997 8.4058 11.76 8.39986 11.8148 8.37715C11.8696 8.35445 11.9165 8.31599 11.9495 8.26666C11.9824 8.21732 12 8.15932 12 8.09999C12 8.02042 11.9684 7.94412 11.9122 7.88786C11.8559 7.83159 11.7796 7.79999 11.7 7.79999Z",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12C3 14.3869 3.94821 16.6761 5.63604 18.364C7.32387 20.0518 9.61305 21 12 21C14.3869 21 16.6761 20.0518 18.364 18.364C20.0518 16.6761 21 14.3869 21 12C21 9.61305 20.0518 7.32387 18.364 5.63604C16.6761 3.94821 14.3869 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12V12Z",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.aadd7d933251e4f2663557032322e149.svg";
export { ForwardRef as ReactComponent };